import { columnFlex, pagePadding } from '../../lib/styles/commonStyles';

export const rootGridSx = {
  ...pagePadding,
  marginBottom: '32px',
};

export const dropdownGridSx = {
  marginBottom: '36px',
};

export const sectionsGridSx = {
  gap: '40px',
  ...columnFlex,
};
